import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import {
  NotificationMessage,
  NotificationPosition,
  NotificationService,
} from '../../../core/services/notification.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  private readonly notificationService = inject(NotificationService);
  readonly notifications$ = this.notificationService.notifications$;
  readonly positions: NotificationPosition[] = [
    'top-right',
    'top-center',
    'top-left',
    'bottom-right',
    'bottom-center',
    'bottom-left',
  ];

  toastsForPosition(
    notifications: NotificationMessage[],
    position: NotificationPosition,
  ): NotificationMessage[] {
    return notifications.filter((toast) => toast.position === position);
  }

  dismiss(notificationId: string): void {
    this.notificationService.dismiss(notificationId);
  }
}
